import React from 'react';
import AvroCompatibilityChecker from './components/AvroCompatibilityChecker';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router';

const avroCompatibilityCheckerPath = '/avro-compatibility-checker';

const App = () => {
  return (
    <React.StrictMode>
      <BrowserRouter>
        <Routes>
          <Route
            path="*"
            element={<Navigate to={avroCompatibilityCheckerPath} />}
          />
          <Route
            path={avroCompatibilityCheckerPath}
            Component={AvroCompatibilityChecker}
          />
        </Routes>
      </BrowserRouter>
    </React.StrictMode>
  );
};

export default App;
